export type BodyVisibilityUiState = {
  labels: boolean;
  objectLabels: boolean;
  bodyLabelMarkers: boolean;
};

export const BODY_VISIBILITY_UI_EVENT = "selected-body-visibility-options-changed";

export const DEFAULT_BODY_VISIBILITY_UI_STATE: BodyVisibilityUiState = {
  labels: false,
  objectLabels: false,
  bodyLabelMarkers: false,
};

let currentBodyVisibilityUiState: BodyVisibilityUiState = {
  ...DEFAULT_BODY_VISIBILITY_UI_STATE,
};

export function getBodyVisibilityUiState(): BodyVisibilityUiState {
  return { ...currentBodyVisibilityUiState };
}

export function setBodyVisibilityUiState(
  patch: Partial<BodyVisibilityUiState>
): BodyVisibilityUiState {
  currentBodyVisibilityUiState = {
    ...currentBodyVisibilityUiState,
    ...patch,
  };
  dispatchBodyVisibilityUiState(currentBodyVisibilityUiState);
  return getBodyVisibilityUiState();
}

export function dispatchBodyVisibilityUiState(state: BodyVisibilityUiState): void {
  currentBodyVisibilityUiState = { ...state };
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(BODY_VISIBILITY_UI_EVENT, {
      detail: { ...state },
    })
  );
}
